import React, { useEffect, lazy } from 'react';
export const OnboardingPage3: React.FC = () => {
  const handleExampleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Here you would typically open a modal or navigate to example page
    window.open('/example-brief.pdf', '_blank');
  };
  // This ensures the Typeform embed is properly initialized
  useEffect(() => {
    // Check if Typeform is loaded
    if (window.typeform) {
      window.typeform.embed.refresh();
    }
  }, []);
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-dark-900 to-dark-800" data-id="element-549">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" data-id="element-550" />
      <div className="flex-1 flex flex-col items-center py-12 px-8 md:px-12" data-id="element-551">
        {/* Logo */}
        <div className="mb-6 w-48 md:w-60" data-id="element-552">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2DzbdAXB8rnWSnnsNSpx4E/widelogo.png" alt="DealFlow.ai Logo" className="w-full h-auto" data-id="element-553" />
        </div>
        {/* Step Indicator */}
        <div className="mb-6 flex items-center justify-center bg-dark-700/50 rounded-full px-8 py-2 backdrop-blur-sm" data-id="element-554">
          <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#00c853] text-white font-medium text-lg mr-4" data-id="element-555">
            3
          </div>
          <span className="text-white font-medium text-lg" data-id="element-556">Step 3/3</span>
        </div>
        {/* Headline */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center mb-10 max-w-4xl" data-id="element-557">
          Please Follow The Steps Below To Continue
        </h1>
        {/* Video Embed */}
        <div className="w-full max-w-4xl mb-10" data-id="element-558">
          <div className="aspect-video w-full bg-dark-700 rounded-xl overflow-hidden shadow-xl border-2 border-dark-500" data-id="element-559">
            <div style={{
            position: 'relative',
            paddingTop: '56.25%'
          }} data-id="element-560">
              <iframe src="https://iframe.mediadelivery.net/embed/460652/37b2f1ca-7aff-4dfb-b49e-87a0783ed2ce?autoplay=false&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
              border: 0,
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%'
            }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-561"></iframe>
            </div>
          </div>
        </div>
        {/* Typeform Embed */}
        <div className="w-full max-w-4xl mb-12" data-id="element-562">
          <div data-tf-live="01JYHVFHA724VYNVRWQ6S1BYYP" data-id="element-563"></div>
        </div>
        {/* Example Section */}
        <div className="w-full max-w-4xl border-2 border-dark-600 rounded-xl p-6 text-center mb-12" data-id="element-564">
          <p className="text-xl md:text-2xl text-white" data-id="element-565">
            Example Creative Brief To Help You With The Next Steps Is{' '}
            <a href="#" onClick={handleExampleClick} className="text-[#00c853] hover:underline font-semibold" data-id="element-566">
              Here
            </a>
          </p>
        </div>
      </div>
    </div>;
};